import React from "react";
import { FaBox, FaTruck, FaClock } from "react-icons/fa";

const CheckoutSummaryCard = ({
  cartCount = 0,
  deliveryOption = "express",
  deliveryFee = 0,
  selectedTimeSlot = "",
}) => {
  const getDeliveryLabel = (opt) => {
    const upper = String(opt || "").toUpperCase();
    if (upper === "SCHEDULED") return "Scheduled Delivery";
    if (upper === "EXPRESS") return "Express Delivery (30 Min)";
    if (upper === "STANDARD") return "Standard Delivery";
    return upper ? `${upper.charAt(0) + upper.slice(1).toLowerCase()} Delivery` : "Standard Delivery";
  };

  const numFee = Number(deliveryFee ?? 0);
  const isScheduled = String(deliveryOption || "").toUpperCase() === "SCHEDULED";

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="grid grid-cols-2 divide-x divide-gray-200 text-xs sm:text-sm">
        {/* Left side: Products */}
        <div className="pr-3 flex items-start gap-3">
          <FaBox className="h-6 w-6 text-[#046a38] mt-0.5 shrink-0" />
          <div>
            <p className="text-gray-500 font-medium">Total Products</p>
            <p className="text-sm sm:text-base font-bold text-[#046a38]">
              {cartCount} Items
            </p>
          </div>
        </div>

        {/* Right side: Delivery Option */}
        <div className="pl-4 flex items-start gap-3">
          <FaTruck className="h-6 w-6 text-[#046a38] mt-0.5 shrink-0" />
          <div>
            <p className="text-gray-500 font-medium">Delivery Option</p>
            <p className="text-xs sm:text-sm font-bold text-[#046a38]">
              {getDeliveryLabel(deliveryOption)}
            </p>
            {isScheduled && selectedTimeSlot && (
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-amber-600">
                <FaClock className="h-3 w-3 shrink-0" />
                {selectedTimeSlot}
              </p>
            )}
            <p className="text-xs text-gray-500">
              Delivery Charge:{" "}
              <span className="font-semibold text-gray-800">
                {numFee === 0 ? "FREE" : `₹${numFee.toFixed(2)}`}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSummaryCard;
